import { useTranslation } from "react-i18next";
import { pillarArticles } from "@/mocks/pillar-articles";
import ArticlePage from "@/components/feature/ArticlePage";

interface PillarArticleProps {
  slug: string;
}

export default function PillarArticle({ slug }: PillarArticleProps) {
  const { i18n } = useTranslation();
  const lang = (i18n.language as "en" | "pt-BR" | "de") || "en";
  const article = pillarArticles[slug];
  const content = article ? article[lang] || article.en : null;

  if (!content) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <p className="text-foreground-600">Article not found.</p>
      </div>
    );
  }

  return <ArticlePage content={content} />;
}